import { createVNode as n, mergeProps as p } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PptTwoTone.js";
import s from "../components/PfIcon.js";
const o = (t, r) => {
  const e = {
    ...t,
    ...r.attrs
  };
  return n(s, p(e, {
    icon: m
  }), null);
};
o.displayName = "PptTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
